import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6632a299"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"height":"74px"}
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center h-100 px-8 v-step-close-modal" }
const _hoisted_3 = { class: "d-flex align-center" }

import { withDefaults, ref, watch } from 'vue';
  import { AtomSubTitle, AtomTitle } from '../atoms';
  import * as comps from '@/components/atoms';
  
  interface IProps {
    show: any;
    disabled?: boolean;
    width?: string;
    icon?: string;
    iconColor?: string;
    el?: any;
    title: string;
    subtitle?: string;
    btnCloseText?: string;
    btnConfirmText?: string;
    paddingY?: string;
    btnConfitmDisabled?: boolean
    hasBtnClose?: boolean
    hasBtnConfirm?: boolean
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalGoal',
  props: {
    show: {},
    disabled: { type: Boolean, default: false },
    width: { default: '477px' },
    icon: {},
    iconColor: {},
    el: { default: 'div' },
    title: {},
    subtitle: {},
    btnCloseText: { default: 'Cancelar' },
    btnConfirmText: { default: 'Importar' },
    paddingY: { default: '0px' },
    btnConfitmDisabled: { type: Boolean },
    hasBtnClose: { type: Boolean, default: true },
    hasBtnConfirm: { type: Boolean, default: true }
  },
  emits: ['HandleCancelGoal', 'HandleConfirmGoal'],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;
  
  const props = __props;
  
  const dialog = ref<boolean>(props.show);
  
  function handleConf() {
    return props.el !== 'form' ? HandleConfirmGoal() : '';
  }
  function HandleCancelGoal() {
    emit('HandleCancelGoal');
  }
  function HandleConfirmGoal() {
    emit('HandleConfirmGoal');
  }
  
  function close() {
    emit('HandleCancelGoal', 'fecha');
  }
  
  watch(
    () => props.show,
    () => (dialog.value = props.show)
  );
  
return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    width: props.width,
    id: "modal-goal"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.el), {
        class: "modal-area",
        onSubmit: _withModifiers(HandleConfirmGoal, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (props.icon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                      key: 0,
                      color: props.iconColor,
                      class: "mr-2"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AtomTitle), {
                  title: props.title,
                  classes: ['title-modal mb-0']
                }, null, 8, ["title"])
              ]),
              _createElementVNode("button", {
                size: "large",
                onClick: close,
                class: "btn-close"
              }, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", {
            class: "body-modal pb-6 mt-6",
            style: _normalizeStyle({ padding: `${props.paddingY ? props.paddingY : '32px'} 32px` })
          }, [
            _renderSlot(_ctx.$slots, "body")
          ], 4)
        ]),
        _: 3
      }, 32))
    ]),
    _: 3
  }, 8, ["modelValue", "width"]))
}
}

})